import React, { useEffect } from 'react';
import { generatePaginatedSitemaps, generateSitemapIndex } from '@/utils/sitemapGenerator';
import { generateMultilingualRoutes } from '@/utils/multilingualRouteGenerator';

interface AutomaticSitemapIntegrationProps {
  baseUrl?: string;
}

/**
 * Component that automatically generates and manages sitemaps
 * This component should be included in the app to ensure sitemaps are always up to date
 */
const AutomaticSitemapIntegration: React.FC<AutomaticSitemapIntegrationProps> = ({ 
  baseUrl = 'https://psychotherapist.help' 
}) => {
  useEffect(() => {
    const generateSitemaps = async () => {
      try {
        // Generate main sitemaps
        const mainSitemaps = await generatePaginatedSitemaps(baseUrl);
        
        // Generate multilingual routes
        const multilingualRoutes = generateMultilingualRoutes();
        
        // Generate sitemap index  
        const totalSitemaps = mainSitemaps.length + 1; // +1 for multilingual sitemap
        const sitemapIndex = generateSitemapIndex(baseUrl, totalSitemaps);
        
        console.log(`📄 Generated ${totalSitemaps} sitemaps with index`);
        console.log(`🌍 Multilingual routes: ${multilingualRoutes.length}`);
        console.log(`📋 Main sitemaps: ${mainSitemaps.length}`);
        
        // In production, these would be saved to the server
        // For now, we just log the generation success
        
      } catch (error) {
        console.error('Error generating sitemaps:', error);
      }
    };

    // Generate sitemaps on mount
    generateSitemaps();
  }, [baseUrl]);

  // This component doesn't render anything visible
  return null;
};

export default AutomaticSitemapIntegration;
